import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-5 col-xl-12" }
const _hoisted_3 = { class: "col-lg-7 col-xl-12" }
const _hoisted_4 = { class: "leads-details-tabs" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs border-0 mb-25",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100 active",
      id: "tasks-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#tasks-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "tasks-tab-pane",
      "aria-selected": "true"
    }, " DATOS GENERALES ")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100",
      id: "emails-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#emails-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "emails-tab-pane",
      "aria-selected": "false"
    }, " HISTORIAL SESIONES ")
  ])
], -1)
const _hoisted_6 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_7 = {
  class: "tab-pane fade show active",
  id: "tasks-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_8 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nombre", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Apellido", -1)
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Correo electrónico / Usuario", -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Perfil", -1)
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Dirección", -1)
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Pais", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Colombia", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Teléfono", -1)
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Notas", -1)
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = { class: "col-md-12" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Estado usuario", -1)
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Designación", -1)
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nombre compañia", -1)
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Sitio web compañia", -1)
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Quien puede ver mi perfil?", -1)
const _hoisted_51 = { class: "col-md-12" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Enlaces redes sociales", -1)
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = { class: "input-group" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-facebook-logo lh-1 fs-md-18" })
], -1)
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_60 = { class: "input-group" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-fill ph-twitter-logo lh-1 fs-md-18" })
], -1)
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_64 = { class: "input-group" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-linkedin-logo lh-1 fs-md-18" })
], -1)
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_68 = { class: "input-group" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-instagram-logo lh-1 fs-md-18" })
], -1)
const _hoisted_70 = { class: "col-md-12" }
const _hoisted_71 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Importar imagen perfil", -1)
const _hoisted_73 = { class: "col-md-12" }
const _hoisted_74 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Cancelar", -1)
const _hoisted_77 = {
  class: "tab-pane fade",
  id: "emails-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_78 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_b_form_radio = _resolveComponent("b-form-radio")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_ImageUpload = _resolveComponent("ImageUpload")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_UserSessionHistory = _resolveComponent("UserSessionHistory")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BreadCrumb, { PageTitle: "Usuarios" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_b_form, {
                  ref: "formRecord",
                  id: "formModal",
                  onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_container, { fluid: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.FirstName,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.FirstName) = $event)),
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "Juan",
                                required: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.LastName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.LastName) = $event)),
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "Perez",
                                required: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.Email,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.Email) = $event)),
                                type: "email",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "adam@edu.com",
                                required: "",
                                disabled: _ctx.form.record.Id > 0
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _createVNode(_component_b_form_select, {
                                modelValue: _ctx.form.record.DutyId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.DutyId) = $event)),
                                class: "form-control fs-14 text-black shadow-none form-control-sm",
                                id: "input-type",
                                required: "",
                                "value-field": "Id",
                                "text-field": "Name",
                                options: _ctx.roles
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.Address,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.Address) = $event)),
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "Ave 6 # 89 - 63"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.Country) = $event)),
                                class: "form-select shadow-none fw-semibold rounded-0"
                              }, _hoisted_30, 512), [
                                [_vModelSelect, _ctx.form.record.Country]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _hoisted_33,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.PhoneNumber,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.PhoneNumber) = $event)),
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "+57 311 123 1234"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _hoisted_36,
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_QuillEditor, {
                                  modelValue: _ctx.form.record.AdditionalInfo,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.record.AdditionalInfo) = $event)),
                                  theme: "snow",
                                  placeholder: "Escriba notas adicionales aquí...",
                                  toolbar: "full"
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("div", null, [
                              _createVNode(_component_b_form_group, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_b_form_radio, {
                                    modelValue: _ctx.form.record.Status,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.record.Status) = $event)),
                                    name: "communicationRadio",
                                    value: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Activo ")
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_b_form_radio, {
                                    modelValue: _ctx.form.record.Status,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.record.Status) = $event)),
                                    name: "communicationRadio",
                                    value: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Desactivado ")
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_b_form_radio, {
                                    modelValue: _ctx.form.record.Status,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.record.Status) = $event)),
                                    name: "communicationRadio",
                                    value: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Bloqueado ")
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.Designation,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.record.Designation) = $event)),
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "Designación del usuario"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _hoisted_45,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.CompanyName,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.record.CompanyName) = $event)),
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "Educa profes"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.CompanyWebsite,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.record.CompanyWebsite) = $event)),
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "http//educaprofes.tech.com"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_b_form_radio, {
                                  modelValue: _ctx.form.record.ProfileVisibility,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.record.ProfileVisibility) = $event)),
                                  name: "communicationRadio2",
                                  value: "soloYo"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Solo yo ")
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(_component_b_form_radio, {
                                  modelValue: _ctx.form.record.ProfileVisibility,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.record.ProfileVisibility) = $event)),
                                  name: "communicationRadio2",
                                  value: "administrador"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Administrador ")
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(_component_b_form_radio, {
                                  modelValue: _ctx.form.record.ProfileVisibility,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.record.ProfileVisibility) = $event)),
                                  name: "communicationRadio2",
                                  value: "todos"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Todos ")
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _hoisted_57,
                                    _createVNode(_component_b_form_input, {
                                      modelValue: _ctx.form.record.Facebook,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.record.Facebook) = $event)),
                                      type: "text",
                                      class: "form-control shadow-none rounded-0 text-black",
                                      placeholder: "facebook@ejemplo.com"
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, [
                                    _hoisted_61,
                                    _createVNode(_component_b_form_input, {
                                      modelValue: _ctx.form.record.Twitter,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.record.Twitter) = $event)),
                                      type: "text",
                                      class: "form-control shadow-none rounded-0 text-black",
                                      placeholder: "twitter@ejemplo.com"
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("div", _hoisted_64, [
                                    _hoisted_65,
                                    _createVNode(_component_b_form_input, {
                                      modelValue: _ctx.form.record.LinkedIn,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.record.LinkedIn) = $event)),
                                      type: "text",
                                      class: "form-control shadow-none rounded-0 text-black",
                                      placeholder: "linkedin@ejemplo.com"
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("div", _hoisted_67, [
                                  _createElementVNode("div", _hoisted_68, [
                                    _hoisted_69,
                                    _createVNode(_component_b_form_input, {
                                      modelValue: _ctx.form.record.Instagram,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.record.Instagram) = $event)),
                                      type: "text",
                                      class: "form-control shadow-none rounded-0 text-black",
                                      placeholder: "instagram@ejemplo.com"
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _hoisted_72,
                              _createVNode(_component_ImageUpload, { filechanged: _ctx.handleFileChange }, null, 8, ["filechanged"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_b_button, {
                                class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                                loading: _ctx.form.loading,
                                type: "submit"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.record.Id ? 'Guardar cambios' : 'Agregar usuario'), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"]),
                              _createVNode(_component_b_button, {
                                onClick: _ctx.cancel,
                                class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_75,
                                  _hoisted_76
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              (_ctx.form.record?.Id)
                ? (_openBlock(), _createBlock(_component_UserSessionHistory, {
                    key: 0,
                    record: _ctx.form.record
                  }, null, 8, ["record"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}